import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import AnimatedText from "../components/AnimatedText";
import Seo from "../components/Seo";

const LegalConsultation = () => {
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="info-page-wrapper font-inter">
      <Seo
        title="Legal Consultation — Legal Platform"
        description="Immediate access to professional legal advice and strategic consultation for all your legal needs."
        canonicalPath="/legal-consultation"
        image="/favicon.png"
      />
      <Header />
      <Breadcrumbs />
      <main className="info-page-section py-5">
        <div
          className="info-page-main-card"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="home-hero-title text-center"><AnimatedText text="Legal Consultation" /></h1>
          <div className="home-hero-text text-center">
            <AnimatedText text="Get professional legal advice tailored to your specific situation. Our verified lawyers provide one-on-one consultations to help you understand your legal rights, explore your options, and make informed decisions about your legal matters." />
          </div>
        </div>

        <div className="info-page-list">
          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Expert Advice" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Connect with legal specialists across various practice areas. Whether you have questions about business law, family matters, or civil rights, our attorneys provide clear and actionable guidance to help you navigate your legal journey." />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Strategic Planning" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Develop a clear roadmap for your legal objectives. We help you identify potential risks, evaluate different legal strategies, and create a plan of action that aligns with your goals and minimizes legal complications." />
            </div>
          </div>

          <div
            className="info-page-block"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <h3 className="info-page-block-title"><AnimatedText text="Document Discussion" /></h3>
            <div className="info-page-block-text">
              <AnimatedText text="Have a professional review and explain complex legal documents to you. We provide clarity on legal terminology, obligations, and implications, ensuring you fully understand any agreement before you commit." />
            </div>
          </div>
        </div>
      </main>
      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
      <Footer />
    </div>
  );
};

export default LegalConsultation;
